const contactEmailParts = ['service.sustell', 'dsm-firmenich', 'com']

export default contactEmailParts